import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  partners: [],
  loading: false,
  error: null,
};
export const deletePartner = createAsyncThunk(
  "partners/deleteParner",
  async (id) => {
    const response = await fetch(
      `https://app.peagle.app/api/courier/destroy/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("login_token"),
        },
      }
    );
    const data = await response.json();
    return data;
  }
);

const PartnerSlice = createSlice({
  name: "couriers",
  initialState,

  extraReducers: {
    [deletePartner.fulfilled]: (state, action) => {
      let index = state.findIndex(({ id }) => id === action.payload.id);
      state.splice(index, 1);
    },
    [deletePartner.fulfilled]: (state, action) => {
      return [];
    },
  },
});
const { reducer, actions } = PartnerSlice;
export default PartnerSlice.reducer;
